import React from 'react';

const Checkmark = () => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    width="22" 
    height="22" 
    viewBox="0 0 22 22" 
    fill="none"
    className="w-[22px] h-[22px] flex-shrink-0"
  >
    <circle cx="11" cy="11.0078" r="11" fill="#CFD3F9"/>
    <path 
      d="M9.93125 15.8382C9.70625 16.0644 9.29375 16.0644 9.06875 15.8382L5.16875 11.9178C4.94375 11.6916 4.94375 11.2769 5.16875 11.0507L6.03125 10.2214C6.25625 9.95755 6.63125 9.95755 6.85625 10.2214L9.51875 12.8602L15.1438 7.20572C15.3687 6.94184 15.7437 6.94184 15.9688 7.20572L16.8313 8.03504C17.0562 8.26122 17.0562 8.67588 16.8313 8.90205L9.93125 15.8382Z" 
      fill="#373E82" 
      fillOpacity="0.75"
    />
  </svg>
);

export default Checkmark; 